export const cleanUpHtml = (htmlString: string) => {
    try {
        return htmlString.replace(/style=("|')[^("|')]*("|')/igm, "");
    } catch (e) {
        return htmlString;
    }
}

export default cleanUpHtml;